export const TEMPORAL_NAMESPACE_ANNOTATION = 'agentfact.tdf/temporal-namespace';
